import { useSnapshot } from "valtio";
import { configStore, viewBookingStore } from "../state/CommonState";
import { Box } from "@mui/material";
import { PricingDetailsCard2 } from "../mui-components/PricingDetailsCard2";
import Utils from "../util/Utils";
import { Accordions } from "../mui-components/AgMuiAccordion";
import { useEffect, useRef, useState } from "react";
import { PricingContextProvider, usePricing } from "../context/PricingContext";
import { useMobile } from "../hooks/usemobile";


function convertRate(e){
    let rate = 0;
    let volumeDiscount = 0.0;
    let erate = configStore.getExchangeRateinr(e)
        if (!erate || erate === 0) erate = 1.0
        if (e.chargeDescription == 'Volume Discount') {
            volumeDiscount = (e.total * erate)
            // if (volumeDiscount > 0) volumeDiscount *= -1
        } else if(e.chargeDescription !== 'Rebate' && e.chargeDescription !== 'Freight Commission'){
            rate = parseFloat(e.total) * erate
        }
        return {rate,volumeDiscount};
}


function getChargesList(chargesList,mode){
   
    let chargeList = [];
    chargesList.forEach(element => {
        let index;
        if(((+element.perCBM) !== 0 || (+element.perShipment) !== 0 || (+element.perTon) !== 0 || (+element.minimum) !== 0 || (+element.maximum) !== 0 || (+element.total) !== 0 ) ){
            let convertedRate = convertRate(element).rate;
             if(element.onaccount==="On Your Account" ){
                 if(chargeList[0]){
                    chargeList[0].charges.push(element);
                 }else{
                    chargeList[0] = {account:"On Your Account",charges:[element],total:0.0,volumeDiscount:0.0,isDiscount:true}
                 }
                
                 index = 0;
                 chargeList[0].volumeDiscount = Math.abs(convertRate(element).volumeDiscount)
             }else if(element.onaccount==="Consignee's Account"){
                if(chargeList[1]){
                    chargeList[1].charges.push(element);
                 }else{
                    chargeList[1] = {account:"On Consignee Account",charges:[element],total:0.0,volumeDiscount:0.0,isDiscount:true}
                 }
               
                 index = 1;
                 chargeList[1].volumeDiscount = Math.abs(convertRate(element).volumeDiscount)
             }else if(element.onaccount?.startsWith('Ship')){
                if(chargeList[2]){
                    chargeList[2].charges.push(element);
                 }else{
                    chargeList[2] = {account:"On Shipper Account",charges:[element],total:0.0,volumeDiscount:0.0,isDiscount:true}
                 }
                
                 index = 2;
                 chargeList[2].volumeDiscount = Math.abs(convertRate(element).volumeDiscount)
             }
             if( (element.isIncluded && element?.isIncluded==="Yes") 
                || mode==="CONTRACT" || mode==="QUOTE" 
            ){
                if(element.isIncluded && element?.isIncluded!=="Yes"){
                     
                }else{
                    console.log(" the charge listr  vis .,. , . m, . m,,,... ",chargeList,"    ",index)
                    if(chargeList[index]){
             chargeList[index].total += convertedRate;
                    }
                }
             }
        }
    });
    return chargeList;
}


 function LCLPricingContextWrapped({contract,isAccordionView,needToDisableInclusion}){
    const context = usePricing() || {};
    const {setRec, setDisable, setTotal, isSpot} = context;
    console.log(" the contract is in context wrap ",contract)
    useEffect(()=>{
        if (contract) {
            if (setRec) setRec(contract);
            if (setDisable) setDisable(needToDisableInclusion);
        }
    },[contract, needToDisableInclusion])
    if (!contract) return <></>;
    const filteredChargesList = getChargesList(Utils.getChargeListFormatFromBooking(contract,isSpot),contract.mode);
    const pkb = contract?.pkb || [];
    const rebate = contract?.rebate || [];
    if((contract.mode==="CONTRACT"|| contract.mode==="QUOTE") && setTotal && filteredChargesList[0]){
        setTotal(filteredChargesList[0]?.total)
    }
    return isAccordionView ? <AccordionViewPricing filteredChargesList={filteredChargesList} pkb={pkb} rebate={rebate} /> : <NonAccordionView filteredChargesList={filteredChargesList} pkb={pkb} rebate={rebate}/>
}

export function LCLBookingPricingDetail({contract,isAccordionView = false,disableInclusion=false}){
    // const context = usePricing();
    // if (!context) {
    //     return (
    //         <PricingContextProvider>
    //             <LCLPricingContextWrapped contract={contract} isAccordionView={isAccordionView} needToDisableInclusion={disableInclusion}/>
    //         </PricingContextProvider>
    //     );
    // }
    return <LCLPricingContextWrapped contract={contract} isAccordionView={isAccordionView} needToDisableInclusion={disableInclusion}/>
}

function AccordionViewPricing({filteredChargesList, pkb,rebate}){
    const [selectedindex,setIndex] = useState(0);
    const accordions = [];
    const isMobile = useMobile()
    filteredChargesList?.forEach((charge,i)=>{
        accordions.push({id: i,
        title: charge.account,
        price: Utils.N(charge.total),
        content: <PricingDetailsCard2 isAccordionView={true} charge={charge} pkb={pkb} rebate={rebate}/>})
    })
    return  filteredChargesList.length === 1 && !isMobile ? <Box sx={{display:"flex",height:"100%",width:"100%"}}>
        <Box sx={{width:"100%",height:"100%", backgroundColor:"white", borderRadius: "10px", paddingY: "8px", paddingX: "12px"}}> <PricingDetailsCard2 title={filteredChargesList[0].account} charge={filteredChargesList[0]}/></Box>
    </Box> : <Accordions accordions={accordions} selectedIndex={selectedindex} setIndex={setIndex} />
}


function NonAccordionView({filteredChargesList, pkb,rebate}){
    console.log(" the lcl list of prving is ",filteredChargesList)
    return <Box sx={{display:"flex",flexDirection:"row",width:"100%",gap:3,justifyContent:"center"}}>
    {filteredChargesList.map((charge)=><Box sx={{minWidth:"30%",paddingY: "8px"}}><PricingDetailsCard2 title={charge.account} charge={charge} pkb={pkb} rebate={rebate}/></Box>)}
  </Box>
}


